// ファイルリストコンポーネント

import React from 'react';
import { UploadedFile } from '../types';
import FileIcon from './FileIcon';
import { getFileType, formatFileSize } from '../utils/fileValidation';
import Spinner from './Spinner';
import Icon from './Icon';
import ProgressBar from './ProgressBar';

interface FileListProps {
  files: UploadedFile[];
  onRemove: (fileId: string) => void;
  showProgress?: boolean;
}

const FileList: React.FC<FileListProps> = ({ 
  files, 
  onRemove, 
  showProgress = false 
}) => {
  if (files.length === 0) {
    return null;
  }

  const getStatusIcon = (status: UploadedFile['status']) => {
    switch (status) {
      case 'uploading':
        return <Spinner size="sm" color="primary" />;
      case 'completed':
        return <Icon type="check" color="text-green-500" />;
      case 'error':
        return <Icon type="x" color="text-red-500" />;
      default:
        return null;
    }
  };

  return (
    <div className="space-y-4">
      <div className="card">
        <div className="divide-y divide-gray-200">
          {files.map((uploadedFile) => {
            const fileType = getFileType(uploadedFile.file);
            
            return (
              <div key={uploadedFile.id} className="p-4 hover:bg-gray-50 transition-colors">
                <div className="flex items-center justify-between">
                  <div className="flex items-center flex-1 min-w-0">
                    {/* ファイルアイコン */}
                    <FileIcon fileType={fileType} className="w-10 h-10 mr-3 flex-shrink-0" />
                    
                    {/* ファイル情報 */}
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center space-x-2">
                        <p className="text-sm font-medium text-gray-900 truncate">
                          {uploadedFile.file.name}
                        </p>
                        {getStatusIcon(uploadedFile.status)}
                      </div>
                      
                      <div className="flex items-center space-x-4 mt-1">
                        <p className="text-xs text-gray-500">
                          {formatFileSize(uploadedFile.file.size)}
                        </p>
                        
                        {uploadedFile.status === 'error' && uploadedFile.error && (
                          <p className="text-xs text-red-500">
                            {uploadedFile.error}
                          </p>
                        )}
                      </div>

                      {/* プログレスバー */}
                      {showProgress && uploadedFile.status === 'uploading' && uploadedFile.progress !== undefined && (
                        <ProgressBar
                          value={uploadedFile.progress}
                          label="アップロード中..."
                          showLabel
                          className="mt-2"
                          animate
                        />
                      )}
                    </div>
                  </div>

                  {/* 削除ボタン */}
                  <button 
                    onClick={() => onRemove(uploadedFile.id)}
                    className="ml-4 p-2 text-gray-400 hover:text-red-500 transition-colors"
                    disabled={uploadedFile.status === 'uploading'}
                  >
                    <Icon type="trash" />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FileList;
